import { createContext, Dispatch } from 'react'
import { RecorderState, RecorderStateDispatch } from './useRecorderStateProvider'

export interface ContextState {
  state: RecorderState
  dispatch: Dispatch<RecorderStateDispatch>
}

export default createContext<ContextState>({} as ContextState)
